export default __webpack_public_path__ + "static/media/img-proj-banpu.37cad24e.png";